import { Users } from "lucide-react";

export const BoardBanner = () => (
  <div
    className="mb-5 rounded-[22px] bg-white border border-[#55D7F3]/60 px-4 py-3 flex items-center gap-3"
    data-testid="board-banner"
  >
    <span className="w-9 h-9 rounded-full bg-[#55D7F3] text-[#14233D] flex items-center justify-center shrink-0">
      <Users size={18} />
    </span>
    <p className="text-[13px] font-semibold leading-snug text-[#14233D]">
      Classifica amici attiva: completa la ciurma per entrare in classifica.
    </p>
  </div>
);
